<template>
    <div id="ii-image">
        <div class="row wrap">
            <div class="hr-title-buttons no-border-top mt-0">
                <div class="title">{{$t('Image')}}</div>
                <div class="buttons">
                </div>
            </div>
            <input-media :label="$t('Base image')" v-model="interactiveImage.base_image" :storieId="interactiveImage.getStoryId()" @change="updateWidthHeight()" required/>
            <div class="col-6" v-if="interactiveImage.isValideBaseImage()">
                <input-text :label="$t('Width')" v-model="interactiveImage.width" after="px" @change="interactiveImage.patch('width')" is-number readonly/>
            </div>
            <div class="col-6" v-if="interactiveImage.isValideBaseImage()">
                <input-text :label="$t('Height')" v-model="interactiveImage.height" after="px" @change="interactiveImage.patch('height')" is-number readonly/>
            </div>
            <div class="col-12">
                <input-select :label="$t('Chapter fade behaviour')" :items="chapterFadeBehaviourValues" :placeholder="$t('Chapter fade behaviour')" v-model="interactiveImage.chapter_fade_behaviour" no-cross @change="interactiveImage.patch('chapter_fade_behaviour')"/>
            </div>
        </div>
        <div class="row wrap">
            <div class="hr-title-buttons">
                <div class="title">{{$t('Bounding zone')}}</div>
                <div class="buttons">
                </div>
            </div>
            <div class="col-12" v-if="interactiveImage.isValideBaseImage() && interactiveImage.chapterHas()">
                <div class="col-12">
                    <input-select :label="$t('Pan types')" :items="panValues" :placeholder="$t('Pan types')" v-model="interactiveImage.type" no-cross/>
                </div>
                <div class="row full-w">
                    <div class="col-6" v-if="interactiveImage.type !== 'pan_vertical'" >
                        <input-text :label="$t('Coord X')" v-model="boundingZoneX" after="px" is-number @change="interactiveImage.patch(['bounding_box','type'])"/>
                    </div>
                    <div class="col-6" v-if="interactiveImage.type !== 'pan_horizontal'">
                        <input-text :label="$t('Coord Y')" v-model="boundingZoneY" after="px" is-number @change="interactiveImage.patch(['bounding_box','type'])"/>
                    </div>
                </div>
                <div class="row full-w">
                    <div class="col-6" v-if="interactiveImage.type === 'pan_zoom'">
                        <input-text :label="$t('Width')" v-model="boundingZoneWidth" after="px" is-number @change="interactiveImage.patch(['bounding_box','type'])"/>
                    </div>
                    <div class="col-6" v-if="interactiveImage.type === 'pan_zoom'">
                        <input-text :label="$t('Height')" v-model="boundingZoneHeight" after="px" is-number @change="interactiveImage.patch(['bounding_box','type'])"/>
                    </div>
                </div>
            </div>
            <div class="col-12" v-else>
                <p class="help" v-if="!interactiveImage.isValideBaseImage() && !interactiveImage.chapterHas()">
                    {{$t('You need to add a valid Base Image and add 1 chapter to manage the bounding zone')}}
                </p>
                <p class="help" v-if="!interactiveImage.isValideBaseImage()">
                    {{$t('You need to add a valid Base Image to manage the bounding zone')}}
                </p>
                <p class="help" v-if="!interactiveImage.chapterHas()">
                    {{$t('You need to add 1 chapter to manage the bounding zone')}}
                </p>
            </div>
        </div>
        <div class="row wrap">
            <div class="hr-title-buttons">
                <div class="title">{{$t('Colors')}}</div>
            </div>
            <div class="col-6">
                <input-color :label="$t('Label')" v-model="interactiveImage.label_color" @change="changeLabelColor" reset/>
            </div>
            <div class="col-6">
                <input-color :label="$t('Background')" v-model="interactiveImage.background_color" @change="changeBackgroundColor" reset/>
            </div>
            <div class="col-12">
                <input-checkbox :label="$t('Show Background color')" v-model="interactiveImage.backgroundColorVisible"/>
            </div>
            <div class="hr-title-buttons">
                <div class="title">{{$t('Other')}}</div>
            </div>
            <div class="col-12">
                <input-checkbox :label="$t('Hide Back button')" v-model="interactiveImage.hide_back_button" @change="interactiveImage.patch('hide_back_button')"/>
            </div>
        </div>
        
    </div>
</template>

<script>

import InputColor from "@/modules/input/input-color";
import InputSelect from "@/modules/input/input-select";
import {interactiveImage} from "@/class/interactive-image/interactiveImage";
import InputMedia from "@/modules/input/input-media";
import InputText from "@/modules/input/input-text";
import Btn from "@/modules/buttons/btn";
import chapter from "@/class/interactive-image/chapter";
import events from "@/events/events";
import InputCheckbox from "@/modules/input/input-checkbox";
export default {
    name: "InteractiveImage_Image",
    components: {InputCheckbox, Btn, InputText, InputMedia, InputSelect,InputColor},
    props:{
        interactiveImage:{type:Object,default:() => new interactiveImage()},
    },
    data(){
        return {
            panValues : [
                {value:'pan_horizontal', text:this.$t('Pan horizontal')},
                {value:'pan_vertical', text:this.$t('Pan vertical')},
                {value:'pan_zoom', text:this.$t('Pan zoom')},
            ],
            chapterFadeBehaviourValues : [
                {value:'additive', text:this.$t('Additive')},
                {value:'sequential', text:this.$t('Sequential')},
            ],
        }
    },
    computed:{
        boundingZone(){
            if(typeof this.interactiveImage.bounding_box[1][1] === "undefined"){
                this.interactiveImage.bounding_box = [[0,0],[0,0]];
            }
            return this.interactiveImage.bounding_box;
        },
        label(){
            return this.interactiveImage.boundingZoneGet();
        },
        boundingZoneX:{
            get(){return this.boundingZone[0][0]; },
            set(value){
                // this.boundingZone[0][0] = value;
                // this.$set(this.boundingZone[0],0,value)
                this.label.x_coord = parseInt(value);
            }
        },
        boundingZoneY:{
            get(){return this.boundingZone[0][1]; },
            set(value){
                // this.boundingZone[0][1] = value;
                // this.$set(this.boundingZone[0],1,value)
                this.label.y_coord = parseInt(value);
            }
        },
        boundingZoneWidth:{
            get(){return this.boundingZone[1][0] - this.boundingZone[0][0]; },
            set(value){
                // this.boundingZone[1][0] = value;
                // this.$set(this.boundingZone[1],0,parseInt(value) + this.boundingZone[0][0])
                this.label.width = parseInt(value);
            }
        },
        boundingZoneHeight:{
            get(){return this.boundingZone[1][1] - this.boundingZone[0][1]; },
            set(value){
                // this.boundingZone[1][1] = value;
                // this.$set(this.boundingZone[1],1,value)
                this.label.height = parseInt(value);
            }
        },
    },
    methods:{
        changeLabelColor(){
            console.log(this.interactiveImage.label_color)
            this.interactiveImage.labelsGetAll().map(l => l.label_color = this.interactiveImage.label_color)
            
            this.interactiveImage.patch("label_color");
        },
        changeBackgroundColor(){
            this.interactiveImage.labelsGetAll().map(l => l.background_color = this.interactiveImage.background_color)
            
            this.interactiveImage.patch("background_color");
        },
        setDefault(){
            switch(this.interactiveImage.type) {
                case "pan_zoom" :
                    this.interactiveImage.bounding_box = [[(this.interactiveImage.width - (this.interactiveImage.height / 2)) / 2 , 0], [((this.interactiveImage.width - (this.interactiveImage.height / 2)) / 2 + (this.interactiveImage.height / 2)),this.interactiveImage.height]];
                    break;
                case "pan_horizontal" :
                    this.interactiveImage.bounding_box = [[0, 0],[0 + 1,this.interactiveImage.height]]
                    break;
                case "pan_vertical" :
                    this.interactiveImage.bounding_box = [[0, 0],[this.interactiveImage.width ,0 + 1]]
                    break;
            }
    
            this.label.x_coord = this.boundingZoneX;
            this.label.y_coord = this.boundingZoneY;
            this.label.width = this.boundingZoneWidth;
            this.label.height = this.boundingZoneHeight;
            this.label.panType = this.interactiveImage.type;
        },
        updateWidthHeight(){
            
            events.$emit("interactive-image:loading",true)
            let img = new Image;
            img.src = this.interactiveImage.base_image.media;
            
            img.onload = () => {
                this.interactiveImage.width = img.width;
                this.interactiveImage.height = img.height;
                
                this.setDefault();
                
                this.interactiveImage.patch(["width","height","base_image"])
                    .then(() => {
                        events.$emit("interactive-image:loading",false)
                    })
                    .catch(() => events.$emit("interactive-image:loading",false))
                
            }
        }
    },
    watch:{
        'interactiveImage.type'(){
            this.setDefault();
            this.interactiveImage.patch(['bounding_box','type'])
        },
        label:{
            handler(){
                this.interactiveImage.bounding_box = [[this.label.x_coord,this.label.y_coord],[this.label.x_coord + this.label.width, this.label.y_coord + this.label.height]];
            },
            deep : true,
        }
    },
    mounted() {
        if(this.interactiveImage.chapterHas()){
            console.log(this.label)
            if(this.label.x_coord === 0 && this.label.y_coord === 0 && this.label.width === 0 && this.label.height === 0){
                this.setDefault()
            }
        }
    },
    created() {
        events.$on("interactive-image:"+this.interactiveImage.pk+":boundingzone:save",() => {
            this.interactiveImage.patch(['bounding_box','type']);
        })
    },
    destroyed() {
        events.$off("interactive-image:"+this.interactiveImage.pk+":boundingzone:save")
    }
}
</script>
